import React, { Component } from 'react'
import './Employes.css'

class Employes extends Component {
    render() {
        return (
            <div >
                <h2>Munkatársak</h2>
                <div className="employees">{this.props.employes.map((employe, index) =>
                    <div className="employee" key={index}>
                      <div className="image">
                        <i className="fa fa-user"/>
                      </div>
                      <div className="employee-data">
                        <h4 className="name">{employe.name}</h4>
                        <div className="details">
                          <div className="datum">
                            <span className="datum-label">Beosztás</span>
                            <span className="datum-value">{employe.title}</span>
                          </div>
                          <div className="datum">
                            <span className="datum-label">Telefon</span>
                            <span className="datum-value">{employe.phone}</span>
                          </div>
                          <div className="datum">
                            <span className="datum-label">Email</span>
                            <span className="datum-value"><a href={'mailto:' + employe.email}>{employe.email}</a></span>
                          </div>
                        </div>
                      </div>
                    </div>
                )}</div>
            </div>
        )
    }
}

export default Employes


// WEBPACK FOOTER //
// ./src/components/employes/Employes.js